export default __webpack_public_path__ + "static/media/upress-vebsayt.8fffa541.jpg";